import { Controller } from '@hotwired/stimulus'

import BigPicture from 'bigpicture'

export default class extends Controller {
  connect() {
    this.assignEventToImage()
  }

  assignEventToImage() {
    this.element.querySelectorAll('img').forEach((el) => {
      el.onclick = () => {
        BigPicture({
          el: el,
          imgSrc: el.src
        })
      }
    })
  }
}
